import { ArrowLeft, ExternalLink, Rows3 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { ontologyGroupStyles } from '@/frontend/features/Fde/ontologyGraphGroups'
import type { SchemaNodeRecord } from '@/frontend/features/Fde/ontologySchemaProjection'
import type { FdeCopy } from '@/frontend/features/Fde/types'

interface Props {
  node: SchemaNodeRecord | null
  copy: FdeCopy
  onClear: () => void
  onOpenElements: (classId: string) => void
  onOpenData: (classId: string) => void
}

export default function OntologySchemaFocusBar({ node, copy, onClear, onOpenElements, onOpenData }: Props) {
  if (!node) return null

  const colors = ontologyGroupStyles[node.group]
  const elementLabel = node.elementCount === 1 ? copy.workspace.element : copy.workspace.elements.toLocaleLowerCase()
  return <div className="flex min-h-12 shrink-0 items-center gap-3 border-b border-border bg-muted/15 px-3 py-2">
    <Button type="button" size="icon-sm" variant="ghost" onClick={onClear} aria-label={copy.workspace.schema_back_previous}><ArrowLeft /></Button>
    <span className={`size-2 shrink-0 rounded-full ${colors.dot}`} />
    <div className="min-w-0 flex-1">
      <div className="flex items-center gap-2"><strong className="truncate text-xs">{node.name}</strong><span className="text-[9px] font-semibold uppercase tracking-wider text-muted-foreground">{node.kind === 'interface' ? copy.workspace.interface : node.kind === 'family' ? copy.workspace.ontology_family : copy.workspace.object_type}</span></div>
      <p className="truncate text-[10px] text-muted-foreground">{node.description || copy.workspace.schema_no_description}</p>
    </div>
    <div className="hidden shrink-0 items-center gap-3 text-[10px] tabular-nums text-muted-foreground lg:flex">
      <span>{node.propertyCount} {copy.workspace.schema_properties}</span>
      <span>{node.linkCount} {copy.workspace.schema_links}</span>
    </div>
    {node.kind === 'class' && <Button type="button" size="sm" variant="outline" onClick={() => onOpenElements(node.recordId)}><Rows3 />{node.elementCount} {elementLabel}</Button>}
    {node.kind === 'class' && node.backingCount > 0 && <Button type="button" size="sm" variant="ghost" onClick={() => onOpenData(node.recordId)}><ExternalLink />{copy.workspace.schema_open_data}</Button>}
  </div>
}
